/**
 * ASCII Art Generator - 预设类型定义
 */

import type { FullRenderSettings } from '../types'
import type { EffectsState } from '../effects/types'

// ============================================
// 预设类型定义
// ============================================

/** 预设类型 */
export interface Preset {
  /** 唯一标识符 */
  id: string
  /** 预设名称 */
  name: string
  /** 预设描述 */
  description: string
  /** 预设分类 */
  category: 'builtin' | 'user'
  /** 创建时间戳 */
  createdAt: number
  /** 渲染参数 */
  settings: FullRenderSettings
  /** 特效状态 */
  effectsState: EffectsState
  /** 缩略图（可选，base64） */
  thumbnail?: string
}

/** 预设分类 */
export interface PresetCategory {
  id: string
  name: string
  description: string
  presets: Preset[]
}

/** 预设元数据（用于列表显示，不含完整参数） */
export interface PresetMeta {
  id: string
  name: string
  description: string
  category: 'builtin' | 'user'
  createdAt: number
  hasThumbnail: boolean
}

// ============================================
// 预设管理器配置
// ============================================

/** 预设管理器配置 */
export interface PresetManagerConfig {
  /** 最大用户预设数量 */
  maxUserPresets: number
  /** 是否自动保存 */
  autoSave: boolean
  /** 本地存储键名 */
  storageKey: string
}

/** 默认预设管理器配置 */
export const DEFAULT_PRESET_MANAGER_CONFIG: PresetManagerConfig = {
  maxUserPresets: 50,
  autoSave: true,
  storageKey: 'ascii-art-user-presets',
}